import { Stop } from "../../../models/stop";
import { StopApiDto } from "../../../models/stop-api-dto";
import { Decimal } from "decimal.js-light";
import { StateCargo } from "../../../ducks/cargo/types";
import { totalLm, totalWeight } from "../../../ducks/cargo";

/** Matches CargoDtos (which can be either pickups or dropoffs) from an unordered list, returning a list of combined "CargoInfo" with pickup- and dropoffs-Cargos */
export const combineCargo = (cargoDtos: StopApiDto[]): StateCargo[] => {
  if (!cargoDtos) return [];

  //Group cargo by InfoId, using a Map (to avoid n^2 runtime)
  const cargoDtosByInfoId = new Map<string, StopApiDto[]>();
  cargoDtos.forEach((cargo) => {
    let arr = cargoDtosByInfoId.get(cargo.cargo_id);
    if (!arr) {
      arr = [];
      cargoDtosByInfoId.set(cargo.cargo_id, arr);
    }
    arr.push(cargo);
  });

  //For each InfoId, we return a combined "CargoInfo"
  const output: StateCargo[] = [];
  cargoDtosByInfoId.forEach((arr) => {
    const first = firstPickup({ cargos: arr });
    if (!first) {
      return;
    }
    output.push({
      //Note: Could improve memory-usage a bit by only copying the relevant props here...
      // ... but that would then be more work when extending the model, so let's only do it if we need the performance

      ...first,
      id: first.cargo_id,
      cargos: arr,
      totalLm: totalLm(arr),
      totalWeight: totalWeight(arr),
    });
  });
  return output;
};

export const isPickup = (cargo: Stop) => {
  // TODO: use property from backend
  return new Decimal(cargo.lm).gt(0);
};

export const isDropoff = (cargo: Stop) => {
  // TODO: use property from backend
  return !isPickup(cargo);
};

export const sortCargoByDateAndId = (
  a: Stop | undefined,
  b: Stop | undefined
): number => {
  if (!a && !b) return 0;
  if (!a?.date) return -1;
  if (!b?.date) return 1;
  if (a === b) return 0;
  return a.date?.localeCompare(b.date) || a.id.localeCompare(b.id);
};

export const firstPickup = <T extends Stop>(info: { cargos: T[] }): T => {
  return info.cargos.filter(isPickup)[0];
};

export const lastDropoff = (info: { cargos: Stop[] }): Stop => {
  const filtered = info.cargos.filter(isDropoff);
  return filtered[filtered.length - 1];
};

export const getLocationText = (
  cargo: Stop | undefined,
  isWide: boolean | undefined
): string | undefined => {
  if (!cargo) return;
  const contrPost = [cargo.country, cargo.postcode]
    .filter((t) => !!t)
    .join("-");
  if (cargo.city && (isWide || !cargo.postcode)) {
    return contrPost ? contrPost + " " + cargo.city : cargo.city;
  }
  return contrPost;
};
